import { UseFormReturn } from "react-hook-form";

import { PanelCompra, CompraSpinner } from "../steps";
import { PaymentWizardSteps } from ".";
import { PaymentWizardError } from "./PaymentWizardError";

import { useWizardOrchestration } from "../../hooks";
import { CheckoutPayload } from "@/schemas/checkout.schema";

// ============================================
// PaymentWizardContent
// ============================================
export const PaymentWizardContent = ({
    onClose,
    methods
}: {
    onClose: () => void;
    methods: UseFormReturn<CheckoutPayload>;
}) => {
    const {
        isLoading,
        error,
        hideBack,
        handleBack,
        handlePanelClose,
    } = useWizardOrchestration(methods, onClose);

    // Render condicional según estado
    const renderContent = () => {
        if (isLoading) {
            return <CompraSpinner message="Procesando..." />;
        }

        if (error) {
            return <PaymentWizardError onClose={handlePanelClose} />;
        }

        return <PaymentWizardSteps onClose={handlePanelClose} />;
    };

    return (
        <PanelCompra hideBack={hideBack} onBack={handleBack} onClose={handlePanelClose}>
            <div className="min-h-[50vh] px-4">
                {renderContent()}
            </div>
        </PanelCompra>
    );
};
